// Imports => Utilities
import {AcLockObject} from '../utilities/ac-lock-object';

export const keys = {
  ACCESS_TOKEN: 'access_token',
  ACCOUNT: 'account',
  ACTIVE: 'Active',
  ASCENDING: 'asc',
  AWAITING: 'awaiting',
  BACKGROUND_COVER: 'bgc',
  BANK: 'bank',
  BANKS: 'banks',
  BANK_ACCOUNT: 'bank_account',
  BANK_ACCOUNTS: 'bank_accounts',
  BANK_REPORT: 'bank_report',
  BANK_REPORTS: 'bank_reports',
  BAR: 'bar',
  BODY: 'body',
  BREADCRUMBS: 'breadcrumbs',
  CANCELLED: 'cancelled',
  CHANGELOG: 'changelog',
  CHARGEBACK: 'chargeback',
  CHART_DATA: 'chart_data',
  CHILDREN: 'children',
  CLOSEABLE: 'closeable',
  CLOSED: 'closed',
  COLLECTION: 'collection',
  COLLECTIVE: 'collective',
  COMPLETED: 'completed',
  CONFIRM: 'confirm',
  CONFIRM_PASSWORD: 'confirm-password',
  CONTEXTUAL_MENU: 'contextual_menu',
  COUNTS: 'counts',
  CREATED: 'created',
  CURRENT: 'current',
  CURRENT_MONTH: 'current_month',
  CURRENT_NAVIGATION: 'current_navigation',
  CURRENT_QUARTER: 'current_quarter',
  CURRENT_WEEK: 'current_week',
  DEB: 'deb',
  DEFAULT: 'default',
  DESCENDING: 'desc',
  DOTS: '...',
  DRAWER: 'drawer',
  DURATION: 'duration',
  EMAIL: 'email',
  ERROR: 'error',
  ESCROW: 'escrow',
  EVENTS: 'events',
  EXPANDED: 'expanded',
  EXPECTED: 'expected',
  EXPIRED: 'expired',
  EXPIRES_AT: 'expires_at',
  EXPIRES_IN: 'expires_in',
  FAILED: 'failed',
  HORIZONTAL: 'horizontal',
  ID: 'id',
  IMPERSONATED_ACCESS_TOKEN: 'impersonated_access_token',
  INCOMING: 'incoming',
  INDIVIDUAL: 'individual',
  ITEM: 'item',
  ITEMS: 'items',
  LAST_15_DAYS: 'last_15_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_7_DAYS: 'last_7_days',
  LAST_90_DAYS: 'last_90_days',
  LIST: 'list',
  LOADED: 'loaded',
  LOCALE: 'locale',
  MAP: 'map',
  MAX: 'max',
  MERCHANT_PROFILES: 'merchant_profiles',
  MESSAGE: 'message',
  MESSAGE_CENTER: 'message_center',
  META: 'meta',
  MIN: 'min',
  MINMAX: 'minmax',
  MODAL: 'modal',
  MULTI_SELECT: 'multi_select',
  NAME: 'name',
  NAVIGATION: 'navigation',
  NEXT: 'next',
  NOTIFICATIONS: 'notifications',
  OBJECT: 'object',
  OBJECT_NO: 'object_no',
  ONHOLD: 'onhold',
  ON_HOLD: 'on_hold',
  OPEN: 'open',
  OPTIONS: 'options',
  OTHER: 'other',
  OUTGOING: 'outgoing',
  PAID: 'paid',
  PASSWORD: 'password',
  PENDING: 'pending',
  PLANNED: 'planned',
  PREVIOUS: 'previous',
  PREVIOUS_MONTH: 'previous_month',
  PREVIOUS_QUARTER: 'previous_quarter',
  PREVIOUS_WEEK: 'previous_week',
  PROFILE: 'profile',
  PROFILES: 'profiles',
  PROGRESS: 'progress',
  RATING: 'rating',
  REFRESH_TOKEN: 'refresh_token',
  REFUND: 'refund',
  REFUNDED: 'refunded',
  REPLIED: 'replied',
  RESERVED: 'reserved',
  REVOKED: 'revoked',
  ROLE: 'role',
  ROLES: 'roles',
  SCROLLER: 'ac-scroller',
  SEARCH_RESULTS: 'search_results',
  SESSION_COOKIE: 'ac-session',
  SETTLEMENT: 'settlement',
  SETTLEMENTS: 'settlements',
  SPECIFICATION: 'speficiation',
  SPECIFICATION_META: 'specification_meta',
  SPECIFICATION_ROWS: 'specification_rows',
  SUB_NAVIGATION: 'sub_navigation',
  SUPPORT_CENTER: 'support_center',
  SUPPORT_EMAIL_ADDRESS: 'support@onlinepaymentplatform.com',
  TABLE_CONTEXTUAL_MENU: 'table_contextual_menu',
  TICKET: 'ticket',
  TICKETS: 'tickets',
  TIME: 'time',
  TIMING: 'timing',
  TITLE: 'title',
  TODAY: 'today',
  TOKEN_TYPE: 'token_type',
  TOTALS: 'totals',
  TRACKING: 'tracking',
  TRACKING_CARRIER: 'tracking_carrier',
  TRACKING_NUMBER: 'tracking_number',
  TRANSACTION: 'transaction',
  TRANSACTIONS: 'transactions',
  TRANSFER: 'transfer',
  UID: 'uid',
  USER: 'user',
  USERS: 'users',
  USER_MENU: 'user_menu',
  VERTICAL: 'vertical',
  VISIBLE: 'visible',
  XUSR_TOKEN: 'xusr_token',
  YESTERDAY: 'yesterday',
  COMPLIANCE_REQUIREMENTS: 'compliance_requirements',
  SETTINGS: 'settings',
  BALANCE: 'balance',
  PROFILE_BALANCE: 'profile_balance',
  REFUNDABLE: 'refundable',
  PURCHASES: 'purchases',
  PURCHASE: 'purchase',
  MOVEMENTS: 'movements',
  MOVEMENT: 'movement',
  WITHDRAWALS: 'withdrawals',
  WITHDRAWAL: 'withdrawal',
  INTERNAL_TRANSFER: 'internal_transfer',
  PAYOUTS: 'payouts',
  REFUND_PAYOUTS: 'refund_payouts',
  CONFIRM_MODAL: 'confirm_modal',
  REFUND_TRANSACTION: 'refund_transaction',
} as const;
export const KEYS = AcLockObject(keys);
export type TKEYS = typeof KEYS;

export default KEYS;
